import {
  Card,
  Col,
  Divider,
  Flex,
  Input,
  Row,
  Switch,
  Tag,
  Typography
} from 'antd'
import { useTranslation } from 'react-i18next'

import { type Organization } from 'src/api/main'

import { PrimaryColorField } from './PrimaryColorField'
import { SignInBackgroundField } from './SignInBackgroundField'

const { Text } = Typography

const renderFieldLabel = (label: string) => (
  <Text
    style={{
      fontSize: 12,
      fontWeight: 500,
      color: 'var(--ant-color-text)',
      display: 'block',
      marginBottom: 6
    }}
  >
    {label}
  </Text>
)

type Props = {
  organization: Organization
}

export const BrandingSection = ({ organization }: Props) => {
  const { t } = useTranslation()

  return (
    <Card
      variant="outlined"
      title={t('workspace.settings.branding.title')}
      extra={
        <Tag style={{ marginInlineEnd: 0 }}>
          {t('workspace.settings.branding.scope')}
        </Tag>
      }
    >
      <Row gutter={14}>
        <Col xs={24} md={8}>
          <PrimaryColorField organization={organization} />
        </Col>
        <Col xs={24} md={8}>
          <SignInBackgroundField organization={organization} />
        </Col>
        <Col xs={24} md={8}>
          {renderFieldLabel(t('workspace.settings.branding.emailFromName'))}
          <Input size="small" defaultValue="Skalx" disabled />
        </Col>
      </Row>

      <Divider style={{ margin: '14px 0 12px' }} />

      <Flex justify="space-between" align="center" gap={14}>
        <Flex vertical style={{ lineHeight: 1.3, flex: 1 }}>
          <Text strong style={{ fontSize: 13 }}>
            {t('workspace.settings.branding.poweredByTitle')}
          </Text>
          <Text type="secondary" style={{ fontSize: 11 }}>
            {t('workspace.settings.branding.poweredByDescription')}
          </Text>
        </Flex>
        <Switch defaultChecked disabled />
      </Flex>
    </Card>
  )
}
